module.exports = __webpack_public_path__ + "static/media/maoRed.f9823db3.svg";